import { render, staticRenderFns } from "./ReminderView.vue?vue&type=template&id=f672b940"
import script from "./ReminderView.vue?vue&type=script&lang=js"
export * from "./ReminderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports